// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentSkeleton_root__f8rMg"};